import { render, staticRenderFns } from "./ChatroomEdit.vue?vue&type=template&id=06561aa0&"
import script from "./ChatroomEdit.vue?vue&type=script&lang=js&"
export * from "./ChatroomEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports